(() => {
  let observer;
  const init = () => {
    observer?.disconnect();
    const active = new Set();
    const targets = document.querySelectorAll('.ss-screenshot__header,.ss-screenshot__form,.ss-studio-intro,.ss-custom-types,.ss-custom-page product-info');
    if (!('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => entry.isIntersecting ? active.add(entry.target) : active.delete(entry.target));
      document.body.classList.toggle('ss-custom-working', active.size > 0);
    });
    targets.forEach(target => observer.observe(target));
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();
